import React, {Component} from "react";
import {connect} from "react-redux";
import Autosuggest from 'react-autosuggest';
import {escapeRegexCharacters, normalizeString} from "./../../helpers/formatters";
import {CLUSTERS_COLORS_MAP} from "./../../helpers/colors";
import {setSelectMapControlAction} from "./../../actions/SettingsAction";
import SVGIcon from "../svg/SVGIcon";

import "./Search.css";

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion.name;

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
  <div>
    {suggestion.type === "Cluster" &&
      <div className="fow-search-suggestion-item">
        <span className="fow-search-legend-color" style={{backgroundColor: CLUSTERS_COLORS_MAP[suggestion.name]}}></span>
        <span className="fow-search-legend-name">{suggestion.name}</span>
      </div>
    }
    {suggestion.type === "Region" &&
      <div className="fow-search-suggestion-item fow-search-suggestion-item-region">
        <span className="fow-search-legend-color"><SVGIcon name="world" fill="transparent" /></span>
        <span className="fow-search-legend-name">{suggestion.name}</span>
      </div>
    }
  </div>
);

const getSectionSuggestions = section => {
  return section.items;
}

const renderSectionTitle = section => {
  return (
    <strong>{section.title}</strong>
  );
}

class Search extends Component {
  constructor(props) {
    super();
    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
    this.state = {
      value: '',
      suggestions: [],
      showSelect: false
    };
    this.getSuggestions = this.getSuggestions.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
  }

  // Teach Autosuggest how to calculate suggestions for any given input value.
  getSuggestions = value => {
    const {searchList, searchDefaultList} = this.props;

    const escapedValue = escapeRegexCharacters(normalizeString(value.trim()));
    if (escapedValue === '' ) {
      return searchDefaultList;
    }

    const score = (a, b) => {
      let score = 0;
      if (a.startsWith(b)) {
        score += 0.5;
      } else if (b.startsWith(a)) {
        score += 0.4;
      }
      score += (1.0 / Math.abs(a.length - b.length));
      return score;
    }

    const resp = searchList
      .map(section => {
        let items = section.items.filter(item => {
          return item.id !== 14 && item.meta.search(escapedValue) !== -1
        });
        return {
          title: section.title,
          items
        };
      })
      .filter(section => section.items.length > 0);

    for (let i=0; i < resp.length; i++) {
      let kind = resp[i];
      kind.items = kind.items.map(x => {
        return {...x, score: score(x.name, escapedValue)}
      }).sort((a,b) => b.score - a.score);
    }

    return resp;
  };

  onChange = (event, {newValue}) => {
    this.setState({
      value: newValue
    });
  };

  onBlur = (event, {newValue}) => {
    this.setState({
      value: '',
      suggestions: [],
      showSelect: false
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({value, reason}) => {
    let showSelect = this.state.showSelect
    if (reason === 'suggestion-selected') {
      showSelect = false;
    }
    this.setState({
      showSelect: showSelect,
      suggestions: this.getSuggestions(value)
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  onSuggestionSelected = (event, {suggestion, suggestionValue, suggestionIndex, sectionIndex, method}) => {
    this.props.setSelectMapControlAction(suggestion, suggestion.type === 'Cluster' ? 'Clusters' : 'Regions', suggestion.type === 'Cluster' ? 'Regions' : 'Clusters');
    this.setState({
      value: '',
      suggestions: []
    });
  }

  clearOnClick = () =>{
    //this.props.setSelectMapControlAction(null);
    this.setState({
      showSelect: !this.state.showSelect,
      suggestions: this.getSuggestions('')
    });
  }

  render() {
    const {value, suggestions, showSelect} = this.state;
    const {selectedCluster, selectedRegion} = this.props;

    const selectedItem = selectedCluster || selectedRegion;

    const selectedName = selectedItem.id === 14 && selectedItem.type === "Cluster" ? 'Select Market Cluster & Region' : selectedItem.name

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: 'Search Clusters & Regions',
      value,
      onChange: this.onChange,
      onBlur: this.onBlur,
      onKeyPress:(e) => {e.key === 'Enter' && e.preventDefault();}
    };

    // Finally, render it!
    return (
      <div className="fow-search">
        {selectedItem &&
          <div className="fow-search-selected-block" onClick={this.clearOnClick}>
          <span>{selectedName}</span><SVGIcon name="arrow-down" stroke="#000" width={30} />
          </div>
        }
        <div className={`fow-search-container ${showSelect ? 'fow-search-show' : 'fow-search-hide'} `}>
          <Autosuggest
            alwaysRenderSuggestions={true}
            suggestions={suggestions}
            multiSection={true}
            focusInputOnSuggestionClick={false}
            onSuggestionSelected={this.onSuggestionSelected}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            renderSectionTitle={renderSectionTitle}
            getSectionSuggestions={getSectionSuggestions}
            inputProps={inputProps}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    searchDefaultList: state.db.search.default,
    searchList: state.db.search.options,
    selectedCluster: state.settings.map["Clusters"],
    selectedRegion: state.settings.map["Regions"]
  };
};
const mapDispatchToProps = dispatch => ({
  setSelectMapControlAction: (data, group, clearGroup) => dispatch(setSelectMapControlAction(data, group, clearGroup)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Search);
